import React from 'react';
import { Box, Typography, TextField, InputAdornment, IconButton , Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from "react-router";

const MiniHeader = () => {
  const navigate = useNavigate();
  return (
   <>
      {/* Mini Header with Gradient */}
      <Box
        sx={{
        //   width: '100%',
          background: 'linear-gradient(to right, #007A6B, #0C5A89)',
          color: 'white',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          px: 2,
          py: 1,
          fontSize: 14,
          paddingRight:"34px"
        }}
        
        className="miniHeaderBar"
      >
        {/* <Typography sx={{ mr: 2, cursor: 'pointer' }} className='contactUsHeading'>CONTACT US</Typography> 
        <span className='lineSpace'> |
        &nbsp; &nbsp; &nbsp; </span> 
        <Typography sx={{ mr: 2, cursor: 'pointer' }}>ENQUIRY</Typography> */}

        {/* Search Box */}
        {/* <TextField
          variant="outlined"
          size="small"
          placeholder="Search"
          sx={{
            backgroundColor: 'white',
            borderRadius: 1,
            input: { padding: '4px 8px' },
            width: { xs: '109px', sm: '160px' },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        /> */}

        <Button className="LoginBtn" onClick={() => navigate('/login')}>Login</Button>
      </Box>

     </>
  );
};

export default MiniHeader;
